import { Routes } from '@angular/router';

import { AgentGuard } from '@core/guards/agent.guard';
import { LifePlanGuard } from '@core/guards/life-plan.guard';
import { CompositeRouteGuard } from '@core/guards/composite.guard';

const AgentRoutes: Routes = [
  {
    path: 'agent/life-plans/:lifePlanId/insurances',
    redirectTo: 'agent/life-plans/:lifePlanId/insurances/death',
    pathMatch: 'full'
  },
  {
    path: 'agent/life-plans/:lifePlanId/insurances/death',
    loadChildren: () => import('./death/death.module').then(m => m.DeathModule),
    data: { routeGuards: [AgentGuard, LifePlanGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/insurances/education',
    loadChildren: () => import('./education/education.module').then(m => m.EducationModule),
    data: { routeGuards: [AgentGuard, LifePlanGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/insurances/savings',
    loadChildren: () => import('./savings/savings.module').then(m => m.SavingsModule),
    data: { routeGuards: [AgentGuard, LifePlanGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/insurances/retirement',
    loadChildren: () => import('./retirement/retirement.module').then(m => m.RetirementModule),
    data: { routeGuards: [AgentGuard, LifePlanGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/insurances/decumulation',
    loadChildren: () => import('./decumulation/decumulation.module').then(m => m.DecumulationModule),
    data: { routeGuards: [AgentGuard, LifePlanGuard] },
    canActivate: [CompositeRouteGuard]
  }
];

export const InsurancesRoutes: Routes = [...AgentRoutes];
